import React from "react";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import CommonTable from "../../../../components/comman/CommonTable";
import FilterComponent from "../../../../components/comman/FilterComponent";
import MainHeading from "../../../../components/comman/MainHeading";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import { saveActiveSalaryHeadTab, updateFiltersStates } from "../../../../store/actions/UserActions";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import EditIcon from "../../../../components/Icons/EditIcon";
import { toast } from "react-toastify";

export default function SalaryHead() {
  const timeoutId = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const ActiveTab = useSelector((state) => state?.root?.activeSalaryHeadTab);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    searchQuery: "",
    salaryHeadList: [],
    type: ActiveTab == 1 ? "earning" : "deduction",
  });

  const GetSalaryHead = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url = apiUrl.get_salary_head + MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy });
    setPageStates((prev) => ({
      ...prev,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((prev) => ({
        ...prev,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.salaryHead?.map((item) => ({
          ...item,
          isBasedOnInitial: item?.isInitialBased ? "Yes" : "No",
          isShowOfferLetter: item?.wantToShowInOfferLetter ? "Yes" : "No",
          isFromEmployeer: item?.fromEmployeer ? "Yes" : "No",
        }));
        setPageStates((pre) => ({
          ...pre,
          salaryHeadList: newData,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActiveSalaryHeadTab(tab));
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        type: "earning",
        currentPage: 1,
      }));
    } else {
      setPageStates((prev) => ({
        ...prev,
        type: "deduction",
        currentPage: 1,
      }));
    }
  };

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  useEffect(() => {
    GetSalaryHead();
  }, [
    pageStates?.currentPage,
    pageStates?.type,
    pageStates?.searchQuery,
    pageStates?.sortByDate,
    pageStates.pageSize,
    filterDetails?.orderBy,
  ]);

  const HandleUpdate = (data) => {
    if (data?.isBase) {
      toast.info("This is Default salary head can't be edited!");
      return
    } else {
      navigate(RoutesLink?.add_salary_head, { state: { data: data } });
    }
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "name", label: "Name" },
    { value: "type", label: "Type" },
    { value: "isShowOfferLetter", label: "Show in Appointment Letter" },
    { value: "isFromEmployeer", label: "From Employer" },
    { value: "isBasedOnInitial", label: "Is Initial Based" },
  ];

  const ActionData = [
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      clickHandler: HandleUpdate,
    },
  ];

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <>
        <div className="content">
          <MainHeading
            title={"Salary Head"}
            buttonText={"Add Salary Head"}
            buttonIcon={<PlusIcon />}
            buttonLink={RoutesLink?.add_salary_head}
          // clickHandler={toggleExpenseModal}
          />
          <Nav tabs className="nav nav-tabs border-0 mb-4">
            <NavItem className="nav-item">
              <NavLink
                className={
                  ActiveTab === 1
                    ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2 active"
                    : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-0 border-start-2"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(1)}
              >
                Earning
              </NavLink>
            </NavItem>
            <NavItem className="nav-item ">
              <NavLink
                className={
                  ActiveTab === 2
                    ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                    : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
                }
                style={{ cursor: "pointer" }}
                onClick={() => toggleTab(2)}
              >
                Deduction
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={ActiveTab}>
            <TabPane tabId={1}>
              <Fade in={ActiveTab === 1} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent handleSearch={handleSearchChange} orderByHandler={orderByHandler} orderByList={orderByList} />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.salaryHeadList}
                      ActionData={ActionData}
                      currentPage={pageStates?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={pageStates?.totalPages}
                      count={pageStates?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={pageStates.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
            <TabPane tabId={2}>
              <Fade in={ActiveTab === 2} timeout={200}>
                <div className="card mb-4">
                  <div className="card-body">
                    <FilterComponent handleSearch={handleSearchChange} orderByHandler={orderByHandler} orderByList={orderByList} />
                    <CommonTable
                      TableHeading={TableHeading}
                      TableData={pageStates?.salaryHeadList}
                      ActionData={ActionData}
                      currentPage={pageStates?.currentPage}
                      PageChangeHandler={PageChangeHandler}
                      isLoading={pageStates?.tableLoader}
                      totalPages={pageStates?.totalPages}
                      count={pageStates?.count}
                      handleChangePageSize={handleChangePageSize}
                      pageSize={pageStates.pageSize}
                    />
                  </div>
                </div>
              </Fade>
            </TabPane>
          </TabContent>
        </div>
      </>
    </>
  );
}
